import React, { Component } from "react";
import {setTitle} from '../../../utils/utils';
import styles from './index.less';
export default class ImageInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {} 
    setTitle('图片信息');
  }

  componentDidMount() {

  }


  render() {
    let countParams = this.props.location.query;
    console.log('image---count---', countParams)
    return (
      <div className={styles.personal}>
        <div className="list"><div className="label">上传认证信息时</div><div className="info">获取{countParams.authCount}次</div></div>
        <div className="list"><div className="label">上传回单时</div><div className="info">获取{countParams.receiptCount}次</div></div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/personalInfo/imageInfo/index.js